<template>
    <p>My Team Section</p>
</template>

<script>
    export default {}
</script>
